module.exports = __webpack_public_path__ + "static/media/231086_200529776655683_5471219_n.0b1550eb.jpg";